
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  getOrderFaultCodeList,
  updataOrderFaultCode
} from "@/api/api-oms-charge-service";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiIrderConfig extends Vue {
  private total = 0;
  private loading = false;
  private formInline: objAny = {
    globalOrder: "",
    globalPageIndex: 1,
    globalPageSize: 10,
    globalSearch: ""
  };
  private isAllOpen = false;
  private isAllClose = false;
  private selectList: object[] = [];
  private ruleInline = {};
  private time: object[] = [];
  private tableList: object[] = [];
  private tableColumns: object[] = [
    {
      type: "selection",
      width: 60,
      align: "center"
    },
    {
      title: i18n.t("orderConfig.enabled"),
      key: "enabled",
      slot: "enabled",
      minWidth: 120
    },
    {
      title: i18n.t("orderConfig.faultName"),
      key: "faultName",
      minWidth: 120
    },

    {
      title: i18n.t("orderConfig.faultCode"),
      key: "faultCode",
      minWidth: 100
    },
    {
      title: i18n.t("orderConfig.faultDesc"),
      key: "faultDesc",
      minWidth: 140
    },
    {
      title: i18n.t("orderConfig.faultTypeDesc"),
      key: "faultTypeDesc",
      minWidth: 160
    }
  ];

  public selectItem(list: object[]) {
    if (list.length > 0) {
      let isAllOpen = true;
      let isAllClose = true;
      list.map((item: objAny) => {
        if (item.enabled) {
          isAllOpen = false;
        } else {
          isAllClose = false;
        }
      });
      this.isAllClose = isAllClose;
      this.isAllOpen = isAllOpen;
    } else {
      this.isAllClose = false;
      this.isAllOpen = false;
    }
    this.selectList = list;
  }

  public queryClick(): void {
    this.formInline.globalPageIndex = 1;
    this.getTableList();
  }
  public pageChange(val: number): void {
    this.formInline.globalPageIndex = val;
    this.getTableList();
  }
  public sizeChange(val: number): void {
    this.formInline.globalPageSize = val;
    this.getTableList();
  }

  public sortChange(column: objAny): void {
    if (column.order === "normal") {
      this.formInline.globalOrder = "";
    } else {
      this.formInline.globalOrder =
        "name=" + column.key + ",age=" + column.order;
    }
    this.getTableList();
  }
  async getTableList(): Promise<void> {
    this.loading = true;
    const ret = await getOrderFaultCodeList(this.formInline);

    if (ret.status === this.$config.apiStatus) {
      this.total = ret.total;
      this.tableList = ret.data;
    }
    this.loading = false;
    this.selectItem([]);
  }

  public allUpClick(enabled: number) {
    const arr: string[] = [];
    this.selectList.map((item: objAny) => {
      arr.push(item.faultCode);
    });
    this.upSub({
      faultCodes: arr,
      enabled: enabled
    });
  }
  async upSub(data: objAny) {
    const ret = await updataOrderFaultCode(data);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.getTableList();
    }
  }

  mounted() {
    this.getTableList();
  }
}
